import { isEmpty } from "lodash-es";
import React from "react";

import { STORE_FILTERS } from "../../storePicker.config";
import { useStorePickerContext } from "../../storePicker.context";
import { StorePickerFilter } from "../../types/storePickerFilter.enum";
import { StorePickerFilterComponent } from "./components/storePickerFilter/storePickerFilter.component";
import "./storePickerFilters.scss";

type StorePickerFiltersProps = {};

export const StorePickerFilters = ({}: StorePickerFiltersProps) => {
    const { activeFilters, toggleFilter, config } = useStorePickerContext();

    const filters = STORE_FILTERS.filter(
        storeFilter =>
            config.displayStockLevel ||
            storeFilter !== StorePickerFilter.FILTER_EMPTY_STOCK,
    );

    if (isEmpty(filters)) return null;

    return (
        <section className={"store-picker-filters"}>
            {/* // TODO - Use this styling when new filters are added in https://redmine.hubo.be/issues/63793 */}
            {/* <div className={"store-picker-filters__title"}>
                <i className={"las la-filter la-lg pr-2"}></i>
                <p>{t("form.searchstore.filteron")}</p>
            </div>
            <ul className={"store-picker-filters__filters"}> */}
            {filters.map(storeFilter => (
                <StorePickerFilterComponent
                    key={storeFilter}
                    storeFeature={storeFilter}
                    active={activeFilters.includes(storeFilter)}
                    onToggle={toggleFilter}
                />
            ))}
            {/* </ul> */}
        </section>
    );
};
